import { localized } from '@lit/localize';
import { html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { renderMessageExtras } from './message-common.js';
import type { ConversationMessage } from './types.js';

@customElement('kv-chat-user-message')
@localized()
export class KvChatUserMessage extends LitElement {
  @property({ attribute: false, hasChanged: () => true })
  accessor message: ConversationMessage | null = null;

  protected createRenderRoot(): this {
    return this;
  }

  render() {
    const message = this.message;
    if (!message) {
      return nothing;
    }

    return html`
      <div class="message user">
        <div class="content">${message.content}</div>
        ${renderMessageExtras(message)}
      </div>
    `;
  }
}
